import { decode } from 'jsonwebtoken';
import { get } from '@cullylarson/f'; // decodes a jwt and gets the data at a specific property

export var getJwtPayload = function getJwtPayload(jwtToken, defaultValue, payloadKey) {
  var tokenDecoded = decode(jwtToken);
  return payloadKey ? get(payloadKey, defaultValue, tokenDecoded) : tokenDecoded;
};